// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================================
   QC Workstation table — match the dense AG Grid look used by the
   Orders / PACS lists (see PacsAgGrid.css): Inter 12px cells, 30px
   compact rows, uppercase 11px header on the steel-gray #AEB9BF bar,
   14px horizontal cell padding, thin cell borders, white / pale-cyan
   zebra striping. The QC list is an antd <Table>, so these mirror the
   AG Grid theme (and its reference RIS palette) by hand.
   ============================================================ */

/* Table font family + container border/radius (like .pacs-ag-grid-container) */

.workstation-table .ant-table {
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  border: 1px solid #e2e8f1;
  border-radius: 0.75rem;
  overflow: hidden;
}

/* Header — 30px, uppercase 11px on the AG Grid header fill */

.workstation-table .ant-table-thead > tr > th.ant-table-cell {
  height: 30px !important;
  padding: 0 14px !important;
  line-height: 1.2 !important;
  background: #AEB9BF !important;
  color: #21323F !important;
  font-weight: 600 !important;
  font-size: 11px !important;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  white-space: nowrap !important;
  border-right: 1px solid #9DA9AF;
  border-bottom: 2px solid #8FA0A8;
}

/* Drop antd's vertical header divider bar so the borders read like AG Grid */

.workstation-table .ant-table-thead > tr > th.ant-table-cell::before {
  display: none !important;
}

.workstation-table .ant-table-thead > tr > th .ant-table-column-title {
  white-space: nowrap !important;
}

/* Body cells — Inter 12px, 14px horizontal padding. Rows are 40px (not the 30px
   header height) to give a wrapped second line room, mirroring the AG Grid
   .ag-cell 2-line-clamp rows used by Orders/PACS/Worklist. */

.workstation-table .ant-table-tbody > tr > td.ant-table-cell {
  height: 40px !important;
  padding: 4px 12px !important;
  font-size: 11px !important;
  line-height: 1.25;
  color: #1a1a1a;
  vertical-align: middle;
  border-right: 1px solid #E4EAEC;
  border-bottom: 1px solid #E4EAEC;
}

/* Belt-and-suspenders: the text cell renderers in constants.tsx now set their
   own 2-line-clamp style (ellipsisCell) directly, so this shouldn't be load-
   bearing — kept in case a future renderer reintroduces an inline nowrap. */

.workstation-table .ant-table-tbody > tr > td.ant-table-cell .col-pat-name span,
.workstation-table .ant-table-tbody > tr > td.ant-table-cell > div {
  white-space: normal !important;
  word-break: break-word;
}

/* Keep the patient-name link (and any inline link buttons) at the 12px cell size
   and let it collapse to content height so it doesn't inflate the 30px row
   (antd buttons are 32px tall by default). */

.workstation-table .ant-table-tbody > tr > td .ant-btn-link {
  height: auto !important;
  padding: 0 !important;
  font-size: 12px !important;
  line-height: 1.4 !important;
}

/* Tighter padding for the leading selection-checkbox column */

.workstation-table .ant-table-selection-column {
  padding-left: 8px !important;
  padding-right: 8px !important;
}

/* Zebra striping (odd #fff / even pale-cyan) to mirror AG Grid rows */

.workstation-table .ant-table-tbody > tr.ws-row-odd > td.ant-table-cell {
  background: #FFFFFF;
}

.workstation-table .ant-table-tbody > tr.ws-row-even > td.ant-table-cell {
  background: #D9EDF3;
}

/* Row hover / selected — match the AG Grid reference cyan palette */

.workstation-table .ant-table-tbody > tr.ant-table-row:hover > td.ant-table-cell {
  background: #C6E5EE !important;
}

.workstation-table .ant-table-tbody > tr.ant-table-row-selected > td.ant-table-cell {
  background: #B7DBE7 !important;
}

/* Priority row tints — mirror the AG Grid tables (PacsAgGrid.css). EMERGENCY is
   a prominent red, ASAP a softer amber; both override the zebra, hover and
   selected backgrounds so the tint persists. EMERGENCY wins (set in rowClassName). */

.workstation-table .ant-table-tbody > tr.ws-emergency-row > td.ant-table-cell {
  background: rgba(226, 75, 74, 0.34) !important;
}

.workstation-table .ant-table-tbody > tr.ws-emergency-row:hover > td.ant-table-cell {
  background: rgba(226, 75, 74, 0.42) !important;
}

.workstation-table .ant-table-tbody > tr.ws-emergency-row.ant-table-row-selected > td.ant-table-cell {
  background: rgba(226, 75, 74, 0.46) !important;
}

/* Strong left accent on the first cell, matching the AG Grid pinned accent bar. */

.workstation-table .ant-table-tbody > tr.ws-emergency-row > td.ant-table-cell:first-child {
  -webkit-box-shadow: inset 5px 0 0 #d32029;
          box-shadow: inset 5px 0 0 #d32029;
}

.workstation-table .ant-table-tbody > tr.ws-asap-row > td.ant-table-cell {
  background: rgba(245, 158, 11, 0.18) !important;
}

.workstation-table .ant-table-tbody > tr.ws-asap-row:hover > td.ant-table-cell {
  background: rgba(245, 158, 11, 0.26) !important;
}

.workstation-table .ant-table-tbody > tr.ws-asap-row.ant-table-row-selected > td.ant-table-cell {
  background: rgba(245, 158, 11, 0.30) !important;
}

.workstation-table .ant-table-tbody > tr.ws-asap-row > td.ant-table-cell:first-child {
  -webkit-box-shadow: inset 5px 0 0 #f59e0b;
          box-shadow: inset 5px 0 0 #f59e0b;
}

/* ===== QC Workstation — Filter Card (page-specific) ===== */

.ws-filters-card {
  background: #fff;
  border-radius: 0.625rem;
  border: 1px solid #E2E8F1;
  padding: 0.625rem 0.875rem;
  margin-bottom: 0.75rem;
}

.ws-filters-row {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
      flex-wrap: wrap;
  -webkit-box-align: end;
      -ms-flex-align: end;
          align-items: flex-end;
  gap: 0.5rem;
}

.ws-field {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
      -ms-flex-direction: column;
          flex-direction: column;
  min-width: 0;
}

.ws-field--name  { width: 10.625rem; }

.ws-field--id    { width: 8.125rem; }

.ws-field--body  { width: 10rem; }

.ws-field--ordno { width: 8.125rem; }

.ws-field--mod   { width: 9.375rem; }

.ws-field--date  { width: 16.25rem; }

.ws-filters-row .ant-input,
.ws-filters-row .ant-picker,
.ws-filters-row .ant-select {
  width: 100% !important;
}

.ws-filter-actions {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  gap: 0.375rem;
  -webkit-box-align: end;
      -ms-flex-align: end;
          align-items: flex-end;
  margin-left: auto;
  -ms-flex-negative: 0;
      flex-shrink: 0;
}

/* Save filter modal styling */

.save-filter-modal {
  -webkit-transform-origin: top center !important;
          transform-origin: top center !important;
}

/* Action-column icons: tinted hover pill matching each icon's hue (set per-icon
   via --ai-hover). Mirrors the PACS / Worklist tables so the QC workstation
   reads the same. The flat icon component self-fades when disabled. */

.action-icon-button {
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  padding: 4px 8px;
  border-radius: 4px;
  cursor: pointer;
  -webkit-transition: background-color 0.2s ease;
  transition: background-color 0.2s ease;
  min-width: 24px;
  min-height: 24px;
}

.action-icon-button:hover {
  background-color: var(--ai-hover, #eef1f5);
}

.action-icon-button.disabled {
  cursor: not-allowed;
}

.action-icon-button.disabled:hover {
  background-color: transparent;
}
`, "",{"version":3,"sources":["webpack://./pages/workstation/workstation.css"],"names":[],"mappings":"AAAA;;;;;;;iEAOiE;;AAEjE,+EAA+E;;AAC/E;EACE,+EAA+E;EAC/E,yBAAyB;EACzB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA,6DAA6D;;AAC7D;EACE,uBAAuB;EACvB,0BAA0B;EAC1B,2BAA2B;EAC3B,8BAA8B;EAC9B,yBAAyB;EACzB,2BAA2B;EAC3B,0BAA0B;EAC1B,yBAAyB;EACzB,qBAAqB;EACrB,8BAA8B;EAC9B,+BAA+B;EAC/B,gCAAgC;AAClC;;AAEA,6EAA6E;;AAC7E;EACE,wBAAwB;AAC1B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;;6DAE6D;;AAC7D;EACE,uBAAuB;EACvB,4BAA4B;EAC5B,0BAA0B;EAC1B,iBAAiB;EACjB,cAAc;EACd,sBAAsB;EACtB,+BAA+B;EAC/B,gCAAgC;AAClC;;AAEA;;4EAE4E;;AAC5E;;EAEE,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA;;6CAE6C;;AAC7C;EACE,uBAAuB;EACvB,qBAAqB;EACrB,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA,8DAA8D;;AAC9D;EACE,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA,sEAAsE;;AACtE;EACE,mBAAmB;AACrB;;AACA;EACE,mBAAmB;AACrB;;AAEA,oEAAoE;;AACpE;EACE,8BAA8B;AAChC;;AACA;EACE,8BAA8B;AAChC;;AAEA;;qFAEqF;;AACrF;EACE,8CAA8C;AAChD;;AACA;EACE,8CAA8C;AAChD;;AACA;EACE,8CAA8C;AAChD;;AACA,kFAAkF;;AAClF;EACE,yCAAiC;UAAjC,iCAAiC;AACnC;;AAEA;EACE,+CAA+C;AACjD;;AACA;EACE,+CAA+C;AACjD;;AACA;EACE,+CAA+C;AACjD;;AACA;EACE,yCAAiC;UAAjC,iCAAiC;AACnC;;AAEA,6DAA6D;;AAC7D;EACE,gBAAgB;EAChB,uBAAuB;EACvB,yBAAyB;EACzB,0BAA0B;EAC1B,sBAAsB;AACxB;;AAEA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,mBAAe;MAAf,eAAe;EACf,sBAAqB;MAArB,mBAAqB;UAArB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,4BAAsB;EAAtB,6BAAsB;MAAtB,0BAAsB;UAAtB,sBAAsB;EACtB,YAAY;AACd;;AAEA,mBAAmB,gBAAgB,EAAE;;AACrC,mBAAmB,eAAe,EAAE;;AACpC,mBAAmB,YAAY,EAAE;;AACjC,mBAAmB,eAAe,EAAE;;AACpC,mBAAmB,eAAe,EAAE;;AACpC,mBAAmB,eAAe,EAAE;;AAEpC;;;EAGE,sBAAsB;AACxB;;AAEA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,aAAa;EACb,sBAAqB;MAArB,mBAAqB;UAArB,qBAAqB;EACrB,iBAAiB;EACjB,oBAAc;MAAd,cAAc;AAChB;;AAEA,8BAA8B;;AAC9B;EACE,+CAAuC;UAAvC,uCAAuC;AACzC;;AAEA;;sEAEsE;;AACtE;EACE,2BAAoB;EAApB,2BAAoB;EAApB,oBAAoB;EACpB,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,8CAAsC;EAAtC,sCAAsC;EACtC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;AAC/B","sourcesContent":["/* ============================================================\r\n   QC Workstation table — match the dense AG Grid look used by the\r\n   Orders / PACS lists (see PacsAgGrid.css): Inter 12px cells, 30px\r\n   compact rows, uppercase 11px header on the steel-gray #AEB9BF bar,\r\n   14px horizontal cell padding, thin cell borders, white / pale-cyan\r\n   zebra striping. The QC list is an antd <Table>, so these mirror the\r\n   AG Grid theme (and its reference RIS palette) by hand.\r\n   ============================================================ */\r\n\r\n/* Table font family + container border/radius (like .pacs-ag-grid-container) */\r\n.workstation-table .ant-table {\r\n  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;\r\n  border: 1px solid #e2e8f1;\r\n  border-radius: 0.75rem;\r\n  overflow: hidden;\r\n}\r\n\r\n/* Header — 30px, uppercase 11px on the AG Grid header fill */\r\n.workstation-table .ant-table-thead > tr > th.ant-table-cell {\r\n  height: 30px !important;\r\n  padding: 0 14px !important;\r\n  line-height: 1.2 !important;\r\n  background: #AEB9BF !important;\r\n  color: #21323F !important;\r\n  font-weight: 600 !important;\r\n  font-size: 11px !important;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.5px;\r\n  white-space: nowrap !important;\r\n  border-right: 1px solid #9DA9AF;\r\n  border-bottom: 2px solid #8FA0A8;\r\n}\r\n\r\n/* Drop antd's vertical header divider bar so the borders read like AG Grid */\r\n.workstation-table .ant-table-thead > tr > th.ant-table-cell::before {\r\n  display: none !important;\r\n}\r\n\r\n.workstation-table .ant-table-thead > tr > th .ant-table-column-title {\r\n  white-space: nowrap !important;\r\n}\r\n\r\n/* Body cells — Inter 12px, 14px horizontal padding. Rows are 40px (not the 30px\r\n   header height) to give a wrapped second line room, mirroring the AG Grid\r\n   .ag-cell 2-line-clamp rows used by Orders/PACS/Worklist. */\r\n.workstation-table .ant-table-tbody > tr > td.ant-table-cell {\r\n  height: 40px !important;\r\n  padding: 4px 12px !important;\r\n  font-size: 11px !important;\r\n  line-height: 1.25;\r\n  color: #1a1a1a;\r\n  vertical-align: middle;\r\n  border-right: 1px solid #E4EAEC;\r\n  border-bottom: 1px solid #E4EAEC;\r\n}\r\n\r\n/* Belt-and-suspenders: the text cell renderers in constants.tsx now set their\r\n   own 2-line-clamp style (ellipsisCell) directly, so this shouldn't be load-\r\n   bearing — kept in case a future renderer reintroduces an inline nowrap. */\r\n.workstation-table .ant-table-tbody > tr > td.ant-table-cell .col-pat-name span,\r\n.workstation-table .ant-table-tbody > tr > td.ant-table-cell > div {\r\n  white-space: normal !important;\r\n  word-break: break-word;\r\n}\r\n\r\n/* Keep the patient-name link (and any inline link buttons) at the 12px cell size\r\n   and let it collapse to content height so it doesn't inflate the 30px row\r\n   (antd buttons are 32px tall by default). */\r\n.workstation-table .ant-table-tbody > tr > td .ant-btn-link {\r\n  height: auto !important;\r\n  padding: 0 !important;\r\n  font-size: 12px !important;\r\n  line-height: 1.4 !important;\r\n}\r\n\r\n/* Tighter padding for the leading selection-checkbox column */\r\n.workstation-table .ant-table-selection-column {\r\n  padding-left: 8px !important;\r\n  padding-right: 8px !important;\r\n}\r\n\r\n/* Zebra striping (odd #fff / even pale-cyan) to mirror AG Grid rows */\r\n.workstation-table .ant-table-tbody > tr.ws-row-odd > td.ant-table-cell {\r\n  background: #FFFFFF;\r\n}\r\n.workstation-table .ant-table-tbody > tr.ws-row-even > td.ant-table-cell {\r\n  background: #D9EDF3;\r\n}\r\n\r\n/* Row hover / selected — match the AG Grid reference cyan palette */\r\n.workstation-table .ant-table-tbody > tr.ant-table-row:hover > td.ant-table-cell {\r\n  background: #C6E5EE !important;\r\n}\r\n.workstation-table .ant-table-tbody > tr.ant-table-row-selected > td.ant-table-cell {\r\n  background: #B7DBE7 !important;\r\n}\r\n\r\n/* Priority row tints — mirror the AG Grid tables (PacsAgGrid.css). EMERGENCY is\r\n   a prominent red, ASAP a softer amber; both override the zebra, hover and\r\n   selected backgrounds so the tint persists. EMERGENCY wins (set in rowClassName). */\r\n.workstation-table .ant-table-tbody > tr.ws-emergency-row > td.ant-table-cell {\r\n  background: rgba(226, 75, 74, 0.34) !important;\r\n}\r\n.workstation-table .ant-table-tbody > tr.ws-emergency-row:hover > td.ant-table-cell {\r\n  background: rgba(226, 75, 74, 0.42) !important;\r\n}\r\n.workstation-table .ant-table-tbody > tr.ws-emergency-row.ant-table-row-selected > td.ant-table-cell {\r\n  background: rgba(226, 75, 74, 0.46) !important;\r\n}\r\n/* Strong left accent on the first cell, matching the AG Grid pinned accent bar. */\r\n.workstation-table .ant-table-tbody > tr.ws-emergency-row > td.ant-table-cell:first-child {\r\n  box-shadow: inset 5px 0 0 #d32029;\r\n}\r\n\r\n.workstation-table .ant-table-tbody > tr.ws-asap-row > td.ant-table-cell {\r\n  background: rgba(245, 158, 11, 0.18) !important;\r\n}\r\n.workstation-table .ant-table-tbody > tr.ws-asap-row:hover > td.ant-table-cell {\r\n  background: rgba(245, 158, 11, 0.26) !important;\r\n}\r\n.workstation-table .ant-table-tbody > tr.ws-asap-row.ant-table-row-selected > td.ant-table-cell {\r\n  background: rgba(245, 158, 11, 0.30) !important;\r\n}\r\n.workstation-table .ant-table-tbody > tr.ws-asap-row > td.ant-table-cell:first-child {\r\n  box-shadow: inset 5px 0 0 #f59e0b;\r\n}\r\n\r\n/* ===== QC Workstation — Filter Card (page-specific) ===== */\r\n.ws-filters-card {\r\n  background: #fff;\r\n  border-radius: 0.625rem;\r\n  border: 1px solid #E2E8F1;\r\n  padding: 0.625rem 0.875rem;\r\n  margin-bottom: 0.75rem;\r\n}\r\n\r\n.ws-filters-row {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  align-items: flex-end;\r\n  gap: 0.5rem;\r\n}\r\n\r\n.ws-field {\r\n  display: flex;\r\n  flex-direction: column;\r\n  min-width: 0;\r\n}\r\n\r\n.ws-field--name  { width: 10.625rem; }\r\n.ws-field--id    { width: 8.125rem; }\r\n.ws-field--body  { width: 10rem; }\r\n.ws-field--ordno { width: 8.125rem; }\r\n.ws-field--mod   { width: 9.375rem; }\r\n.ws-field--date  { width: 16.25rem; }\r\n\r\n.ws-filters-row .ant-input,\r\n.ws-filters-row .ant-picker,\r\n.ws-filters-row .ant-select {\r\n  width: 100% !important;\r\n}\r\n\r\n.ws-filter-actions {\r\n  display: flex;\r\n  gap: 0.375rem;\r\n  align-items: flex-end;\r\n  margin-left: auto;\r\n  flex-shrink: 0;\r\n}\r\n\r\n/* Save filter modal styling */\r\n.save-filter-modal {\r\n  transform-origin: top center !important;\r\n}\r\n\r\n/* Action-column icons: tinted hover pill matching each icon's hue (set per-icon\r\n   via --ai-hover). Mirrors the PACS / Worklist tables so the QC workstation\r\n   reads the same. The flat icon component self-fades when disabled. */\r\n.action-icon-button {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  padding: 4px 8px;\r\n  border-radius: 4px;\r\n  cursor: pointer;\r\n  transition: background-color 0.2s ease;\r\n  min-width: 24px;\r\n  min-height: 24px;\r\n}\r\n\r\n.action-icon-button:hover {\r\n  background-color: var(--ai-hover, #eef1f5);\r\n}\r\n\r\n.action-icon-button.disabled {\r\n  cursor: not-allowed;\r\n}\r\n\r\n.action-icon-button.disabled:hover {\r\n  background-color: transparent;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
